import { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { ToastTooltip } from 'components/ToastTooltip';
import { CopyIcon16 } from 'modules/icons/CopyIcon16';
import { QRCodeSVG } from 'qrcode.react';

import CopyChecked from '../../../images/copy_checked.svg';

import { TransactionCommonDialog } from './TransactionCommonDialog';

interface TransactionCommonProps {
  open: boolean;
  onClose: () => void;
  currentSafe: string;
}

// TODO_R: [FRS]
const useStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: '#ababab',
    fontSize: '14px',
    lineHeight: '22px',
    margin: '0 0 32px',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    borderRadius: '8px',
    border: '1px solid #E7E7E9',
    background: '#FFFFFF',
  },
  qrcode: {
    display: 'grid',
    justifyItems: 'center',
    gap: '24px',
  },
  copyCode: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    background: '#34353b',
    cursor: 'pointer',
    '& > p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#FAFAFA',
      [theme.breakpoints.down('xs')]: {
        width: '250px',
      },
    },
    '& > div': {
      display: 'flex',
    },
    '& svg': {
      color: '#ABABAB',
      width: 16,
      height: 16,
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
}));

// TODO_R: [FRS]
// TODO_R: move into SafeDetailsPage/components/
export const ReceiveDialog = (props: TransactionCommonProps) => {
  const { open, onClose, currentSafe } = props;

  const [copyTooltipShown, setCopyTooltipShown] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(currentSafe);
    if (copyTooltipShown) {
      return;
    }
    setCopyTooltipShown(true);
    setTimeout(() => {
      setCopyTooltipShown(false);
    }, 3 * 1000);
  };

  const classes = useStyles();

  return (
    <TransactionCommonDialog open={open} title="Vault address" button="" onClose={onClose}>
      <div className={classes.wrapper}>
        <span className={classes.description}>
          Use the vault address to deposit any Stacks assets
        </span>
        <div className={classes.qrcode}>
          <div
            className={classes.copyCode}
            onClick={(e) => {
              e.stopPropagation();
              handleCopyClick();
            }}
          >
            <p>{currentSafe}</p>
            <ToastTooltip
              style={{ width: '80%' }}
              open={copyTooltipShown}
              message="Copied"
              icon={CopyChecked}
              placement="top"
            >
              <CopyIcon16 />
            </ToastTooltip>
          </div>
          {currentSafe && (
            <div className={classes.imageWrapper}>
              <QRCodeSVG value={currentSafe} size={178} />
            </div>
          )}
        </div>
      </div>
    </TransactionCommonDialog>
  );
};
